import { NavLink, Outlet, Link } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Phone, LayoutDashboard, CalendarDays, Smartphone, LogOut, Home } from "lucide-react";

export default function AdminLayout() {
  const { user, logout } = useAuth();

  const linkCls = ({ isActive }) =>
    `flex items-center gap-2.5 px-3.5 py-2.5 rounded-lg text-sm transition ${
      isActive
        ? "bg-[var(--burgundy)] text-white"
        : "text-[var(--ink)] hover:bg-[var(--beige-100)]"
    }`;

  return (
    <div className="min-h-screen bg-[var(--beige-50)] flex flex-col md:flex-row">
      <aside className="md:w-64 md:min-h-screen bg-white border-b md:border-b-0 md:border-r border-[rgba(110,30,43,0.08)] p-5 md:p-6 flex md:flex-col gap-3 md:gap-2 items-center md:items-stretch overflow-x-auto">
        <Link to="/" className="hidden md:flex items-center gap-2 mb-6">
          <span className="w-9 h-9 rounded-full bg-[var(--burgundy)] text-white flex items-center justify-center">
            <Phone size={15} />
          </span>
          <span className="font-serif text-xl">Telefonka</span>
        </Link>
        <NavLink to="/admin" end className={linkCls} data-testid="nav-bookings"><LayoutDashboard size={16} />Foglalások</NavLink>
        <NavLink to="/admin/calendar" className={linkCls} data-testid="nav-calendar"><CalendarDays size={16} />Naptár</NavLink>
        <NavLink to="/admin/devices" className={linkCls} data-testid="nav-devices"><Smartphone size={16} />Eszközök</NavLink>
        <div className="md:mt-auto md:pt-6 flex md:flex-col gap-2 md:gap-3 items-center md:items-stretch ml-auto md:ml-0">
          {user && (
            <div className="hidden md:flex items-center gap-2 px-3 py-2 rounded-lg bg-[var(--beige-100)] text-xs text-[var(--ink-soft)]">
              {user.picture && <img src={user.picture} alt="" className="w-6 h-6 rounded-full" />}
              <span className="truncate">{user.email}</span>
            </div>
          )}
          <Link to="/" className="text-xs flex items-center gap-1.5 tk-link-soft px-2"><Home size={13} />Főoldal</Link>
          <button onClick={logout} data-testid="logout-btn" className="text-xs flex items-center gap-1.5 px-3 py-2 rounded-lg border border-[rgba(44,31,26,0.18)] hover:border-[var(--burgundy)] hover:text-[var(--burgundy)] transition">
            <LogOut size={13} />Kijelentkezés
          </button>
        </div>
      </aside>
      <main className="flex-1 p-5 md:p-10 max-w-full overflow-x-auto">
        <Outlet />
      </main>
    </div>
  );
}
